import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Industries from './pages/Industries';
import WhyPegasus from './pages/WhyPegasus';
import Clients from './pages/Clients';
import KnowledgeHub from './pages/KnowledgeHub';
import Contact from './pages/Contact';
import ServiceDetail from './components/ServiceDetail';
import { servicesData } from './data/servicesData';
import '@/App.css';

// Scroll to top on route change + Intersection Observer for fade-in
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add('visible');
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );
    const observe = () => {
      document.querySelectorAll('.fade-in').forEach((el) => observer.observe(el));
    };
    observe();
    const interval = setInterval(observe, 1000);
    return () => { observer.disconnect(); clearInterval(interval); };
  }, [pathname]);

  return null;
};

function App() {
  return (
    <BrowserRouter>
      <div className="App min-h-screen flex flex-col">
        <ScrollToTop />
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/why-pegasus" element={<WhyPegasus />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/knowledge-hub" element={<KnowledgeHub />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Service Detail Routes */}
            <Route
              path="/services/fda"
              element={<ServiceDetail service={servicesData['fda']} pageKey="fda" />}
            />
            <Route
              path="/services/cdsco"
              element={<ServiceDetail service={servicesData['cdsco']} pageKey="cdsco" />}
            />
            <Route
              path="/services/global-regulatory"
              element={<ServiceDetail service={servicesData['global-regulatory']} pageKey="regulatory-affairs" />}
            />
            <Route
              path="/services/gmp"
              element={<ServiceDetail service={servicesData['gmp']} pageKey="gmp" />}
            />
            <Route
              path="/services/who-gmp"
              element={<ServiceDetail service={servicesData['who-gmp']} pageKey="gmp" />}
            />
            <Route
              path="/services/specialized"
              element={<ServiceDetail service={servicesData['specialized']} pageKey="cosmetic-food" />}
            />
            <Route
              path="/services/facility-design"
              element={<ServiceDetail service={servicesData['facility-design']} pageKey="facility-design" />}
            />
            <Route
              path="/services/turnkey"
              element={<ServiceDetail service={servicesData['turnkey']} pageKey="turnkey" />}
            />
            <Route
              path="/services/drug-sourcing"
              element={<ServiceDetail service={servicesData['drug-sourcing']} pageKey="drug-sourcing" />}
            />
            {/* Backward compatibility redirects */}
            <Route
              path="/services/regulatory-affairs"
              element={<ServiceDetail service={servicesData['global-regulatory']} pageKey="regulatory-affairs" />}
            />
            <Route
              path="/services/cosmetic-food"
              element={<ServiceDetail service={servicesData['specialized']} pageKey="cosmetic-food" />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
